import axios from "../request/axios";
import API from "../request/api";

const authService = {
  info() {
    return axios.get(API.userInfo);
  },
  authPermissions() {
    return axios.get(API.authPermissions);
  },
};

export default authService;
